import { Component, OnInit, Output, EventEmitter, Injector } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
// import {ReCaptchaV3Service} from 'ng-recaptcha';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
declare var $: any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends BaseClass<any> implements OnInit {

  loginForm!: FormGroup;
  submitted = false;
  @Output() closeLogin = new EventEmitter();
  @Output() forceChangePwd = new EventEmitter();
  public bsModalRef!: BsModalRef;
  rmCheck: any;
  usernameInput:any;
  passwordInput:any;
  public isLoadDemo: boolean = false;
  
  constructor(public service: WebserviceService,
    private fb: FormBuilder,
    private router: Router,
    private _shared: SharedService,
    public _message: MessageService,
    private injector: Injector,
    protected _common: CommonService,
  ) {
    super();
  }

  ngOnInit(): void {

    $(function () {
      var body = $('body');
      body.addClass('login-background');
      body.removeClass('loading');
    });

    $(".psddhideshow").click(() => {
      var input = $('#password-field');      
      if (input.attr("type") == "password") {
        $(".toggle-password").removeClass("fa-eye").addClass("fa-eye-slash");
        input.attr("type", "text");
      } else {
        $(".toggle-password").removeClass("fa-eye-slash").addClass("fa-eye");
        input.attr("type", "password");
      }
    });

    this.rmCheck = document.getElementById("rememberMe");
    this.usernameInput = document.getElementById("username");
    this.passwordInput = document.getElementById("password-field");

    if (localStorage.checkbox && localStorage.checkbox !== "") {
      this.rmCheck.setAttribute("checked", "checked");
      this.loginForm = this.fb.group({
        username: [localStorage.username, Validators.required],
        password: [localStorage.password, Validators.required],
        // termsCondition: ['', Validators.required],
      });
    } else {
      this.rmCheck.removeAttribute("checked");
      this.loginForm = this.fb.group({
        username: ['', Validators.required],
        password: ['', Validators.required],
        // termsCondition: ['', Validators.required],
      });
    }
  }

  get f() {
    return this.loginForm.controls;
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  onSubmit(key: any = '') {
    this.submitted = true;

    if (key != 'demo') {
      if (this.rmCheck.checked && this.usernameInput.value !== "" && this.passwordInput.value !== "") {
        localStorage.username = this.usernameInput.value;
        localStorage.password = this.passwordInput.value;
        localStorage.checkbox = this.rmCheck.value;
      } else {
        localStorage.username = "";
        localStorage.password = "";
        localStorage.checkbox = "";
      }
    }

    // stop here if form is invalid
    if (key != 'demo') {
      if (this.loginForm.invalid) {
        if (this.f.username.errors) {
          this._message.errmessage("Please enter valid username");
        }else if (this.f.password.errors) {
          this._message.errmessage("Please enter valid password");
        }
        return;
      }

      if (key == 'demo') { this.isLoadDemo = true; } else { this.isLoad = true }
      let req = {
        "username": this.loginForm.value.username,
        "password": this.loginForm.value.password,
        "domain": this.env.baseUrl
      }
      // alert('SUCCESS!! :-)\n\n' + JSON.stringify(req, null, 4));
      this.login('', req);

    } 
    else 
    {
      let req = {
        "username": 'Demo123',
        "password": '123456',
        "domain": this.env.domain
      }
      this.login('demo', req);
    }
  }

  login(key: any = '', req: any) {
    this.getServices().login(`${this.env.baseUrl + this.api.login}`, req).subscribe(
      (res) => {

        if (res.status == true) {
          if (key == 'demo') { this.isLoadDemo = false; res.data.user['dr'] = true; /* dr means demo login */ } else { this.isLoad = false }
          let expiry = new Date();
          expiry.setSeconds(expiry.getSeconds() + res.data.expires_in);
          localStorage.removeItem(`${this.env.panel}marquee`);
          localStorage.setItem(`${this.env.panel}marquee`, res.data.message);
          localStorage.removeItem(`${this.env.panel}user`);
          localStorage.setItem(`${this.env.panel}user`, JSON.stringify(res.data.user));
          localStorage.removeItem(`${this.env.panel}id_token`);
          localStorage.setItem(`${this.env.panel}id_token`, `${res.data.token_type} ${res.data.access_token}`);
          localStorage.removeItem(`${this.env.panel}expiry`);
          localStorage.setItem(`${this.env.panel}expiry`, `${expiry}`);
          localStorage.removeItem(`${this.env.panel}stakes`);
          localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(res.data.stakes));

          this.array_move(res.data.event_type_settings);
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(res.data.event_type_settings));

          this.closeModal();
          this._shared.emitLoginData({ isLogin: true });
          
          this.router.navigate(['/inplay']);

        } else {
          if (key == 'demo') { this.isLoadDemo = false } else { this.isLoad = false }
          if (res.error.code == 1003) {
            localStorage.removeItem(`${this.env.panel}id_token`);
            localStorage.setItem(`${this.env.panel}id_token`, `${res.data.token_type} ${res.data.access_token}`);
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res.error.message);
          }
        }
      },
      (err) => {
        if (key == 'demo') { this.isLoadDemo = false } else { this.isLoad = false }
        this._message.errmessage(err?.error?.message);
        // this.closeLogin.emit('');
      });
  }

  closeModal() {
    this.bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    this.bsModalRef.hide();
  }

  
}
